import React from 'react';

import { Alert, PageTitle } from 'src/common/ui/components';
import { SmartTable } from 'src/common/ui/components/SmartTable';
import PrescriptionTaskStatusBadge from 'src/prescriptionTasksQueue/PrescriptionTaskStatusBadge';
import { usePrescriptionTasks } from 'src/prescriptionTasksQueue/hooks/usePrescriptionTasks';

export const PrescriptionTasksQueue = () => {
  const { prescriptionTasks, error, isLoading } = usePrescriptionTasks();

  if (error) {
    return <Alert title="Error loading prescription tasks" error={error} severity="error" />;
  }

  if (isLoading) {
    return (
      <div style={{ padding: '24px' }}>
        <PageTitle>Prescription Tasks Queue</PageTitle>
        <div>Loading prescription tasks...</div>
      </div>
    );
  }

  const columns = [
    {
      key: 'patientId' as const,
      label: 'Patient ID',
      sortable: true,
    },
    {
      key: 'eventId' as const,
      label: 'Event ID',
      sortable: true,
    },
    {
      key: 'status' as const,
      label: 'Status',
      sortable: true,
    },
    {
      key: 'rnNote' as const,
      label: 'Note',
      sortable: false,
    },
    {
      key: 'createdAt' as const,
      label: 'Created',
      sortable: true,
    },
  ];

  const tableData = prescriptionTasks
    ? prescriptionTasks
        .sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime())
        .map(task => ({
          id: task.id,
          patientId: <a href={`/patients/${task.patientId}`}>{task.patientId}</a>,
          eventId: <a href={`/events/${task.eventId}`}>{task.eventId}</a>,
          status: <PrescriptionTaskStatusBadge status={task.status} />,
          rnNote: task.rnNote,
          createdAt: task.createdAt.toLocaleString(),
        }))
    : [];

  return (
    <div style={{ padding: '24px' }}>
      <PageTitle>Prescription Tasks Queue</PageTitle>
      {prescriptionTasks && prescriptionTasks.length > 0 ? (
        <SmartTable columns={columns} data={tableData} rowsPerPageOptions={[100, 200, 300]} />
      ) : (
        <div>No prescription tasks found</div>
      )}
    </div>
  );
};
